import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Highlight from "components/ui/atoms/Highlight";
import FormHeader from "components/ui/atoms/FormHeader";

const CreateFormHeader = ({}) => {
  const theme = useTheme();

  return (
    <Highlight color={theme.palette_custom.yellow}>Create people</Highlight>
  );
};

const UpdateFormHeader = ({ people }) => {
  const theme = useTheme();

  return (
    <>
      <Highlight color={theme.palette_custom.yellow}>
        {people.best_name}
      </Highlight>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          ml: "auto",
        }}
      >
        People: {people.id}
      </Box>
    </>
  );
};

const PeopleFormHeader = ({ formType, onClose, ...props }) => {
  let header;
  if (formType == "create") header = <CreateFormHeader {...props} />;
  if (formType == "update") header = <UpdateFormHeader {...props} />;

  return <FormHeader onClose={onClose}>{header}</FormHeader>;
};

export default PeopleFormHeader;
